interface PrintIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const PrintIcon = (props: PrintIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{ fill: fillColor }}
        d="M27.2,31.3H11.6V10.7c0-0.2-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v21c0,0.2,0.2,0.4,0.4,0.4h0
            h16c0.2,0,0.4-0.3,0.4-0.5C27.5,31.5,27.4,31.3,27.2,31.3z"
      />
      <path
        style={{ fill: fillColor }}
        d="M29.3,13.5c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1-0.1-0.1L24,7.9l0,0c0,0-0.1-0.1-0.1-0.1l0,0
            h-0.1H13c-0.2,0-0.4,0.2-0.4,0.4v21.5c0,0.2,0.2,0.4,0.4,0.4h15.9c0.2,0,0.4-0.2,0.4-0.4V13.5C29.3,13.5,29.3,13.5,29.3,13.5z
            M24.1,9.3l3.7,3.8h-3.7V9.3z M13.4,29.4V8.7h9.9v4.8c0,0.2,0.2,0.4,0.4,0.4h4.7v15.4L13.4,29.4L13.4,29.4z"
      />
    </svg>
  )
}

export default PrintIcon
